import React, { createContext, useContext, useState, useEffect, useCallback } from "react"
import { authFetch } from "../lib/api"

const AuthContext = createContext(null)

const TOKEN_KEY = "vista_token"

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [token, setTokenState] = useState(null)
  const [loading, setLoading] = useState(true)

  const setToken = useCallback((newToken) => {
    setTokenState(newToken)
    if (newToken) localStorage.setItem(TOKEN_KEY, newToken)
    else localStorage.removeItem(TOKEN_KEY)
  }, [])

  const login = useCallback((newToken, newUser) => {
    setToken(newToken)
    setUser(newUser)
  }, [setToken])

  const logout = useCallback(() => {
    setToken(null)
    setUser(null)
  }, [setToken])

  useEffect(() => {
    const stored = localStorage.getItem(TOKEN_KEY)
    if (!stored) {
      setLoading(false)
      return
    }
    setTokenState(stored)
    authFetch("/api/auth/me")
      .then((res) => {
        if (res.ok) return res.json()
        throw new Error("Invalid session")
      })
      .then((data) => setUser(data.user))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY)
        setTokenState(null)
        setUser(null)
      })
      .finally(() => setLoading(false))
  }, [])

  const value = { user, token, loading, login, logout, setUser }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error("useAuth must be used within AuthProvider")
  return ctx
}
